import { SortableDefinitionsType, SortableType } from "@/components/@types";
import { Icon } from "@/components/atoms/Icon";
import { Popper } from "@/components/atoms/Popper";
import { List } from "@/components/organisms/List";
import { SortChipDefinitionRow } from "@/components/organisms/UtilityBar/SortChip/SortChipDefinitionRow";
import { icons } from "@/objects/@icons";
import { useSortChipState } from "@/components/organisms/UtilityBar/FilterChip/FilterChipStateContext";
import { Button } from "@/components/ui/button";
import { Typography } from "@/components/ui/typography";

export function SortChipNameSection({
  index,
  sortables,
  ReactIcon,
  sortableDefinition,
  dropdownOpenIndexes,
  setDropdownOpenIndexes,
}: {
  index: number;
  sortables: SortableType[];
  ReactIcon: any;
  sortableDefinition: SortableDefinitionsType;
  dropdownOpenIndexes: any[];
  setDropdownOpenIndexes: (value: any) => void;
}) {
  const { sortableDefinitions, setSortables } = useSortChipState();

  return (
    <Popper
      isOpenState={[
        dropdownOpenIndexes[index]?.name,
        (isOpen) => {
          const newDropdownOpenIndexes = [...dropdownOpenIndexes];
          newDropdownOpenIndexes[index] = {
            ...newDropdownOpenIndexes[index],
            name: isOpen,
          };
          setDropdownOpenIndexes(newDropdownOpenIndexes);
        },
      ]}
      anchor={
        <Button
          variant="secondary"
          size="sm"
          data-testid={`sort-chip-name-${sortableDefinition?.name}`}
          className="w-40 justify-start"
        >
          {ReactIcon && (
            <Icon
              ReactIcon={ReactIcon}
              size="sm"
              style={{
                color:
                  "color-mix(in oklab, var(--muted-foreground) 80%, transparent)",
              }}
            />
          )}
          <Typography className="truncate overflow-hidden text-ellipsis">
            {sortableDefinition?.name}
          </Typography>
          <div className="grow" />
          <icons.chevronDown
            size="1em"
            style={{
              color:
                "color-mix(in oklab, var(--muted-foreground) 80%, transparent)",
              transform: "translateY(1px)",
            }}
          />
        </Button>
      }
      floatingStyle={{ padding: 0 }}
    >
      <List
        data={Object.keys(sortableDefinitions).map((key) => ({
          key,
          ...sortableDefinitions[key],
        }))}
        onItemClick={(sortableDefinition) => {
          setDropdownOpenIndexes((prev: any) => {
            const newDropdownOpenIndexes = [...prev];
            newDropdownOpenIndexes[index] = {
              ...prev[index],
              name: false,
            };
            return newDropdownOpenIndexes;
          });
          const newSortables = [...sortables];
          newSortables[index] = {
            ...sortableDefinition,
            value: sortableDefinition.operators?.[0]?.key,
          };
          setSortables(newSortables);
        }}
      >
        <List.Items>
          {(sortableDefinition: any) => (
            <List.Item
              value={sortableDefinition}
              data-testid={`sort-name-option-${sortableDefinition.name}`}
            >
              <SortChipDefinitionRow sortableDefinition={sortableDefinition} />
            </List.Item>
          )}
        </List.Items>
      </List>
    </Popper>
  );
}
